export function RequiredStar() {
  return (
    <span className="required-star" aria-hidden>*</span>
  );
}
